import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalClose } from 'client/components/Helpers/Modal';
import propTypes from 'prop-types';
import UserEditPanel from 'client/components/User/UserEditPanel';

export default class UserEditModal extends Component {

  static defaultProps = {
    open: false,
  };

  static propTypes = {
    user: propTypes.object,
    open: propTypes.bool,
    onClose: propTypes.func.isRequired,
    onUserWasUpdated: propTypes.func,
  };

  render () {
    const { onClose, open, user, onUserWasUpdated } = this.props;
    const { displayName } = user;
    return (
      <Modal dialogClassName="colored-header colored-header-primary" show={open} onHide={onClose} backdrop="static">
        <Modal.Header className="modal-header">
          <ModalClose onClose={onClose} />
          <Modal.Title>{displayName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserEditPanel id={user.id} onUpdated={onUserWasUpdated} />
        </Modal.Body>
      </Modal>
    );
  }

}
